import React from 'react';
import styled from 'styled-components';
import { Typo } from 'tmt-ui-kit';
import PropTypes from 'prop-types';

import config from '~/config';
import { GalleryName, getGalleryProps } from '~/utils/gallery';

import MiniGallery from './MiniGallery';
import Remark from './Remark';
import Menus from './Menus';

const Container = styled.div`
  margin-top: 16px;
`;

const Title = styled(Typo.HeaderTwo)`
  display: flex;
  align-items: center;
  margin: 0;
  margin-bottom: 16px;
  span {
    display: block;
    margin-left: 6px;
    a {
      margin-left: 6px;
    }
  }
  a:last-child:hover {
    color: ${props => props.theme.red};
  }
  @media screen and (max-width: 600px) {
    display: block;
  }
`;

const LocalTableContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  ${props => (!props.restaurant
    ? `border: 1px solid ${props.theme.blueGray};`
    : `background: ${props.theme.blueGrayLighter};`)}
  border-radius: 10px;
  padding: 32px;
  ul {
    padding-left: 18px;
    margin-top: 0;
    ${props => (!props.restaurant ? 'margin-bottom: 24px;' : 'margin-bottom: 28px;')}
    li {
      p { 
        margin: 0;
      }
    }
  }
  @media screen and (max-width: 900px) {
    padding: 16px 32px;
  }
  @media screen and (max-width: 700px) {
    display: block;
    padding: 16px;
  }
`;

const Logo = styled.img`
  display: block;
  @media(max-width: 600px) {
    margin-bottom: 8px;
  }
`;

const Col = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  @media(max-width: 600px) {
    margin-bottom: 16px;
  }
`;

const RestaurantLink = styled.a`
  color: ${props => props.theme.orange};
`;

const LocalTable = props => {
  const { trip, menus, type } = props;
  const isRestaurant = type !== 'homeCooking';
  const galleryProps = getGalleryProps(trip, GalleryName.LOCAL_TABLE);
  return (
    <Container>
      <Title>
        <a href={`${config.baseURL.en}/localtable`} target="_blank" rel="noopener noreferrer">
          <Logo
            src={`${config.assetPath}/static/images/TripDetail/local-table-logo.png`}
            srcSet={`${config.assetPath}/static/images/TripDetail/local-table-logo@2x.png 2x`}
            alt="LocalTable"
          />
        </a>
        {isRestaurant && (
          <span>
            at
            <RestaurantLink href={`${config.baseURL.en}/localtable/restaurant/${trip.restaurant_ids[0].slug}`} target="_blank" rel="noopener noreferrer">
              {trip.restaurant_ids[0].name}
            </RestaurantLink>
          </span>
        )}
      </Title>
      <LocalTableContainer restaurant={isRestaurant}>
        <Col>
          <Menus
            menus={menus}
          />
          <Remark type={type} />
        </Col>
        {galleryProps.images && galleryProps.images.length > 0 && (
          <Col>
            <MiniGallery images={galleryProps.images} defaultAlt={galleryProps.defaultAlt}/>
          </Col>
        )}
      </LocalTableContainer>
    </Container>
  );
};

LocalTable.propTypes = {
  trip: PropTypes.object,
  menus: PropTypes.array,
  type: PropTypes.string
};

export default LocalTable;
